import { useState, useEffect } from 'react';
import { get, set } from 'bv-local-storage';
import {
  get as getBalance,
  subscribe,
  unsubscribe,
} from 'bv-services/account-balance';
import BalanceView from './balance_view';

const BalanceContainer = () => {
  const [showBalance, setShowBalance] = useState(!get('hide_balance'));
  const [balance, setBalance] = useState();

  // Effect to get balance initially and subscribe to balance changes
  useEffect(() => {
    getBalance().then(setBalance);
    subscribe(setBalance);

    return () => {
      unsubscribe(setBalance);
    };
  }, []);

  const setShowBalanceWithLS = (show) => {
    setShowBalance(show);
    set('hide_balance', !show);
  };

  if (!balance) return null;

  return (
    <BalanceView
      showBalance={showBalance}
      setShowBalance={setShowBalanceWithLS}
      balance={balance}
    />
  );
};

export default BalanceContainer;
